import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParticipantMessageService } from 'src/app/core/services/participant-message.service';

@Component({
  selector: 'app-unsuscribe',
  templateUrl: './unsuscribe.component.html',
  styleUrls: ['./unsuscribe.component.scss']
})
export class UnsuscribeComponent implements OnInit {
  errors: { [key: string]: string[] };
  token: string;
  isUnsubscribe: boolean = false;
  message: string;

  constructor(private route: ActivatedRoute, 
    private participantMessage:ParticipantMessageService,
    public router: Router) { 
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      console.log('Token:', this.token);
    });
  }

  ngOnInit(): void {
    this.isUnsubscribe = false;
  }

  unsubscribe() {
    this.isUnsubscribe = false;
    this.participantMessage.unsubscribe(encodeURIComponent(this.token)).subscribe((result: any) => {
      this.isUnsubscribe = true;
      if(result === 'OK') {
        this.updateMessage('Thank you. You will no longer receive emails from SoliMarket.');
      }
    }, (error) => {
      this.isUnsubscribe = true;
      this.errors = error?.errors;
      this.updateMessage(error?.text);
    })
  }

  updateMessage(message: string) {
    this.message = message;
    this.router.navigate(["/auth/unsubscribe"]);
  }
}
